import styled from "styled-components";

export const ZaproszeniePageStyle = styled.div`
  display: grid;
  grid-template-rows: auto 1fr;
  padding: 40px 64px;
  height: 100%;

  header {
    display: grid;
    grid-template-columns: auto auto;
    justify-content: space-between;

    div {
      text-align: left;
    }

    button {
      width: 200px;
      height: 48px;
    }
  }

  main {
    display: grid;
    grid-template-rows: 348px 96px 1fr;
    grid-gap: 40px;
    justify-items: center;

    h4 {
      width: 640px;
      text-align: center;
    }

    button {
      width: 256px;
      height: 48px;
      margin-right: 24px;
      font-size: 16px;
    }
  }

  .info {
    display: grid;
    grid-template-rows: 315px 65px;
    grid-gap: 40px;
    justify-items: center;
    align-content: center;
  }
`;
